import { isNativeDevice } from "../Platform";
import { generateUUID, sessionStorageProp } from "../Utils";
import { IStoreEvent, IStoreGate } from "./EventsStore";

class Session {

    protected _pin: string;
    protected _deviceId: string;

    constructor() {

        sessionStorageProp(this, "activeEvent");
        sessionStorageProp(this, "activeGate");

        this._pin = localStorage.getItem("Code") as string;

        this._deviceId = localStorage.getItem("DeviceId");

        if (!this._deviceId) {

            if (isNativeDevice())
                this._deviceId = nativeDevice.getSerial();
            else
                this._deviceId = generateUUID();

            this.updateDeviceId(this._deviceId);
        }
    }   

    updateDeviceId(value: string) {
        this._deviceId = value;
        localStorage.setItem("DeviceId", value);
    }

    get deviceId() {
        return this._deviceId
    }

    isValid() { 
        return this._pin != null;
    }

    async openAsync(pin: string) {
        this._pin = pin;
        this.activeGate = null;
        this.activeEvent = null;
        localStorage.setItem("Code", pin);
        return true;
    }

    get pin() {
        return this._pin;
    }

    activeEvent: IStoreEvent;

    activeGate: IStoreGate;
}

const session = new Session();

export default session;